import React from "react";
import Typewriter from "typewriter-effect";
import { FaDownload } from "react-icons/fa";
import img from "../imgs/DSC_47511.jpg";
import Tooltip from "./reutilizables/icons";

const HeroSection = ({ language }) => {
  const handleDownloadCV = () => {
    const link = document.createElement("a");
    link.href = "/cv_Julian.pdf";
    link.setAttribute("download", "Julián_Abril_CV.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const texts = {
    en: { title: "HI, I'M", downloadCV: "Download CV" },
    es: { title: "HOLA, SOY", downloadCV: "Descargar CV" },
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-center bg-black text-white min-h-screen px-4 py-8 md:px-12">
      {/* Contenido de Texto */}
      <div className="text-center md:text-left space-y-4 md:space-y-6 w-full md:w-1/2">
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-jersey leading-none">
          {texts[language].title}
        </h1>
        <div
          className="text-3xl sm:text-5xl md:text-7xl font-jersey text-teal-400 leading-none"
          style={{ width: "100%", maxWidth: "400px", whiteSpace: "nowrap" }}
        >
          <Typewriter
            options={{
              strings: [`JULIÁN ABRIL<span style="color: white;">.</span>`],
              autoStart: true,
              loop: true,
            }}
          />
        </div>

        {/* Botón de descarga */}
        <div className="flex flex-col sm:flex-row justify-center md:justify-start items-center gap-4 mt-6">
          <button
            onClick={handleDownloadCV}
            title="Descargar el currículum de Julián Abril"
            className="bg-teal-500 hover:bg-teal-600 text-lg sm:text-xl font-semibold py-2 sm:py-3 px-6 sm:px-7 rounded-full shadow-lg transition duration-300 flex items-center space-x-2"
          >
            <FaDownload className="text-lg sm:text-2xl" />
            <span className="font-paragraph">{texts[language].downloadCV}</span>
          </button>
          <Tooltip />
        </div>
      </div>

      {/* Imagen (solo en móviles se ajusta el tamaño) */}
      <div className="mt-6 w-48 h-48 sm:w-56 sm:h-56 md:w-80 md:h-80 flex-shrink-0">
        <img
          src={img}
          alt="Julián Abril - Desarrollador Full Stack especializado en React y Python"
          className="rounded-full object-cover shadow-2xl w-full h-full"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default HeroSection;
